export default __webpack_public_path__ + "static/media/element_spec_39.c9f7bec1.webp";